import { render, staticRenderFns } from "./manageCourse.vue?vue&type=template&id=386dfaac&scoped=true&"
import script from "./manageCourse.vue?vue&type=script&lang=js&"
export * from "./manageCourse.vue?vue&type=script&lang=js&"
import style0 from "./manageCourse.vue?vue&type=style&index=0&id=386dfaac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386dfaac",
  null
  
)

export default component.exports